import {
  array,
  boolean,
  Infer,
  number,
  object,
  optional,
  string,
  union,
  nullable,
  func,
} from 'superstruct';
import { Url } from '../types/commonTypes';

export const SwipeGamesItemSchema = object({
  gameIconUrl: string(),
  gameDropdownUrl: string(),
  gameId: number(),
  hasPff: optional(boolean()),
  colorGradient: array(string()),
  tileImgUrl: optional(string()),
  displayName: optional(string()),
  minigameImgUrl: optional(nullable(string())),
  subProvider: optional(nullable(string())),
});

export const GameListConfigSchema = object({
  remoteApiEnable: boolean(),
  remoteApiEndPoint: optional(Url),
  requestHeaders: object(),
  routeParams: object(),
  queryString: object(),
  gameList: array(SwipeGamesItemSchema),
  gamesOverride: optional(nullable(array(union([string(), number()])))),
});

export const SwipeGameResponseSchema = object({
  data: array(
    object({
      id: number(),
      gameId: number(),
      description: string(),
      configuration: string(),
    }),
  ),
});

export const SwipeGamesConfigSchema = object({
  playForFunMode: boolean(),
  enableDesktop: optional(boolean()),
  swipeIconCollapse: optional(
    object({
      enabled: optional(boolean()),
      collapseIconAfter: optional(number()),
      enableCollapseMenu: optional(boolean()),
    }),
  ),
  iconPosition: string(),
  homeIconUrl: Url,
  styles: object({
    iconBgColor: string(),
    iconTop: number(),
  }),
  gameListConfig: GameListConfigSchema,
  gameLaunchConfig: object({
    remoteApiEnable: boolean(),
    remoteApiEndPoint: Url,
    requestHeaders: object(),
    routeParams: object(),
    queryString: object(),
    initialGameLauncherUrl: optional(Url),
  }),
  urlCallbackFn: optional(nullable(func())),
});

export const SwipeGameListItemSchema = object({
  description: string(),
  displayName: optional(string()),
  tagLine: optional(string()),
  tags: optional(array(string())),
  colourGradient: optional(array(string())),
  coverImgUrl: optional(Url),
  iconImgUrl: optional(Url),
  largeIconImgUrl: optional(Url),
  tileImgUrl: optional(Url),
  gameId: number(),
  hasPff: optional(boolean()),
  locale: optional(string()),
  minigameImgUrl: optional(nullable(string())),
  subProvider: optional(nullable(string())),
});

export const SwipeGamesListSchema = object({
  tenantId: string(),
  listType: string(),
  games: array(SwipeGameListItemSchema),
});

export type SwipeGamesItem = Infer<typeof SwipeGamesItemSchema>;
export type SwipeGamesConfig = Omit<
  Infer<typeof SwipeGamesConfigSchema>,
  'urlCallbackFn'
> & {
  urlCallbackFn?:
    | ((
        nonce: string,
        metadata?: { gameId: string },
      ) => void | Promise<{ url: string; nonce: string } | void>)
    | null;
};
export type SwipeGameListItem = Infer<typeof SwipeGameListItemSchema>;
export type SwipeGamesList = Infer<typeof SwipeGamesListSchema>;

export type GameListConfig = Infer<typeof GameListConfigSchema>;

// Public schemas and types for games override array
export const GamesOverrideItemSchema = union([string(), number()]);
export const GamesOverrideArraySchema = array(GamesOverrideItemSchema);
export type GamesOverrideItem = Infer<typeof GamesOverrideItemSchema>;
export type GamesOverride = Infer<typeof GamesOverrideArraySchema> | null;
